var items = {
  "block.minecraft.air": "ஏர்",
  "block.minecraft.stone": "கல்",
  "block.minecraft.granite": "கிரானைட்",
  "block.minecraft.polished_granite": "பளபளப்பான கிரானைட்",
  "block.minecraft.diorite": "diorite",
  "block.minecraft.polished_diorite": "பளபளப்பான diorite",
  "block.minecraft.andesite": "அண்டிசைட்",
  "block.minecraft.polished_andesite": "பளபளப்பான ஆண்டிசைட்",
  "block.minecraft.grass_block": "குறுக்கு பிளாக்",
  "block.minecraft.dirt": "டர்ட்",
  "block.minecraft.coarse_dirt": "கரடுமுரடான அழுக்கு",
  "block.minecraft.podzol": "podzol",
  "block.minecraft.crimson_nylium": "கிரிம்சன் நைலியம்",
  "block.minecraft.warped_nylium": "வார்ப் நைலியம்",
  "block.minecraft.cobblestone": "உருளைக்கல்",
  "block.minecraft.oak_planks": "ஓக் பிளாங்க்ஸ்",
  "block.minecraft.spruce_planks": "ஸ்ப்ரூஸ் ப்ளாங்க்கள்",
  "block.minecraft.birch_planks": "பிர்ச் பிளாங்க்ஸ்",
  "block.minecraft.jungle_planks": "ஜங்கிள் பிளாங்க்ஸ்",
  "block.minecraft.acacia_planks": "அகாசி ப்ளான்ஸ்",
  "block.minecraft.dark_oak_planks": "டார்க் ஓக் பிளாங்குகள்",
  "block.minecraft.crimson_planks": "கிரிம்சன் பலகைகள்",
  "block.minecraft.warped_planks": "திசைதிருப்பப்பட்ட பலகைகள்",
  "block.minecraft.oak_sapling": "ஓக் சப்பாளி",
  "block.minecraft.spruce_sapling": "ஸ்ப்ரெஸ் சந்தா",
  "block.minecraft.birch_sapling": "பிர்ச் சப்பாளிங்",
  "block.minecraft.jungle_sapling": "ஜங்கிள் சந்திப்பு",
  "block.minecraft.acacia_sapling": "அகாசி சப்பாளி",
  "block.minecraft.dark_oak_sapling": "டார்க் ஓக் சப்பாளி",
  "block.minecraft.bedrock": "அடிநிலப்பாறை",
  "block.minecraft.sand": "மணல்",
  "block.minecraft.red_sand": "சிவப்பு மணல்",
  "block.minecraft.gravel": "சரளை",
  "block.minecraft.gold_ore": "தங்க ஓரே",
  "block.minecraft.iron_ore": "இரும்பு தாது",
  "block.minecraft.coal_ore": "நிலக்கரி ஓரே",
  "block.minecraft.nether_gold_ore": "நெதர் தங்க தாது",
  "block.minecraft.oak_log": "ஓக் பதிவு",
  "block.minecraft.spruce_log": "ஸ்ப்ரூஸ் பதிவு",
  "block.minecraft.birch_log": "பிர்ச் பதிவு",
  "block.minecraft.jungle_log": "ஜங்கிள் பதிவு",
  "block.minecraft.acacia_log": "அகாசியா பதிவு",
  "block.minecraft.dark_oak_log": "டார்க் ஓக் புகுபதிகை",
  "block.minecraft.crimson_stem": "கிரிம்சன் ஸ்டெம்",
  "block.minecraft.warped_stem": "வார்ப் ஸ்டெம்",
  "block.minecraft.stripped_oak_log": "ஸ்ட்ரெபிட் ஓக் லா",
  "block.minecraft.stripped_spruce_log": "ஸ்ட்ரைப்ஸ் ஸ்ட்ரீப் பதிவு",
  "block.minecraft.stripped_birch_log": "பிர்ச் பதிவு ஸ்ட்ரிப்ட்",
  "block.minecraft.stripped_jungle_log": "ஜங்கிள் பதிவு இழுக்கப்பட்டது",
  "block.minecraft.stripped_acacia_log": "அகாசியா பதிவை அகற்றினார்",
  "block.minecraft.stripped_dark_oak_log": "ஸ்டிரிப்டு டார்க் ஓக் புகுபதிகை",
  "block.minecraft.stripped_crimson_stem": "அகற்றப்பட்ட கிரிம்சன் ஸ்டெம்",
  "block.minecraft.stripped_warped_stem": "அகற்றப்பட்ட வார்ப் ஸ்டெம்",
  "block.minecraft.stripped_oak_wood": "ஓக் வுட் ஸ்ட்ரைப்ட்",
  "block.minecraft.stripped_spruce_wood": "ஸ்ட்ரைப்ஸ் ஸ்ப்ரூஸ் வூட்",
  "block.minecraft.stripped_birch_wood": "பிர்ச் வூட் ஸ்ட்ரிப்ட்",
  "block.minecraft.stripped_jungle_wood": "ஜங்கிள் வூட் ஸ்ட்ரைப்ஸ்",
  "block.minecraft.stripped_acacia_wood": "அக்ஸா வூட் ஸ்ட்ரிப்ட்",
  "block.minecraft.stripped_dark_oak_wood": "ஸ்ட்ரிப்ட் டார்க் ஓக் வூட்",
  "block.minecraft.stripped_crimson_hyphae": "அகற்றப்பட்ட கிரிம்சன் ஹைஃபே",
  "block.minecraft.stripped_warped_hyphae": "அகற்றப்பட்ட வார்ப் ஹைஃபே",
  "block.minecraft.oak_wood": "கருவாலி மரம்",
  "block.minecraft.spruce_wood": "ஸ்ப்ரூ வூட்",
  "block.minecraft.birch_wood": "பிர்ச் மரம்",
  "block.minecraft.jungle_wood": "ஜங்கிள் வூட்",
  "block.minecraft.acacia_wood": "அகாசி வூட்",
  "block.minecraft.dark_oak_wood": "டார்க் ஓக் வூட்",
  "block.minecraft.crimson_hyphae": "கிரிம்சன் ஹைஃபே",
  "block.minecraft.warped_hyphae": "வார்ப்பட் ஹைஃபே",
  "block.minecraft.oak_leaves": "ஓக் இலைகள்",
  "block.minecraft.spruce_leaves": "ஸ்ப்ரூஸ் இலைகள்",
  "block.minecraft.birch_leaves": "பிர்ச் இலைகள்",
  "block.minecraft.jungle_leaves": "ஜங்கிள் இலைகள்",
  "block.minecraft.acacia_leaves": "அகாசி இலைகள்",
  "block.minecraft.dark_oak_leaves": "டார்க் ஓக் இலைகள்",
  "block.minecraft.sponge": "கடற்பாசி",
  "block.minecraft.wet_sponge": "வெட் கடற்பாசி",
  "block.minecraft.glass": "கண்ணாடி",
  "block.minecraft.lapis_ore": "லாபீஸ் லஸுலி ஓரே",
  "block.minecraft.lapis_block": "லேபிஸ் லாஜூலி பிளாக்",
  "block.minecraft.dispenser": "வழங்கு",
  "block.minecraft.sandstone": "மணற்கல்",
  "block.minecraft.chiseled_sandstone": "சிஸ்டெல் சாண்ட்ஸ்டோன்",
  "block.minecraft.cut_sandstone": "வெட்டு மணல்",
  "block.minecraft.note_block": "குறிப்பு தடு",
  "block.minecraft.powered_rail": "திருத்தினோம் ரயில்",
  "block.minecraft.detector_rail": "கண்டறிதல் ரயில்",
  "block.minecraft.sticky_piston": "ஒட்டும் பிஸ்டன்",
  "block.minecraft.cobweb": "கோப்வெப்",
  "block.minecraft.grass": "புல்",
  "block.minecraft.fern": "பன்னம்",
  "block.minecraft.dead_bush": "டெட் புஷ்",
  "block.minecraft.seagrass": "கடல் புல்",
  "block.minecraft.sea_pickle": "கடல் பிகில்",
  "block.minecraft.piston": "பிஸ்டன்",
  "block.minecraft.white_wool": "வெள்ளை கம்பளி",
  "block.minecraft.orange_wool": "ஆரஞ்சு கம்பளி",
  "block.minecraft.magenta_wool": "மெஜந்தா கம்பளி",
  "block.minecraft.light_blue_wool": "லைட் ப்ளூ கம்பளி",
  "block.minecraft.yellow_wool": "மஞ்சள் கம்பளி",
  "block.minecraft.lime_wool": "சுண்ணாம்பு கம்பளி",
  "block.minecraft.pink_wool": "பிங்க் கம்பளி",
  "block.minecraft.gray_wool": "சாம்பல் கம்பளி",
  "block.minecraft.light_gray_wool": "ஒளி சாம்பல் கம்பளி",
  "block.minecraft.cyan_wool": "சியான் கம்பளி",
  "block.minecraft.purple_wool": "ஊதா வூல்",
  "block.minecraft.blue_wool": "ப்ளூ கம்பளி",
  "block.minecraft.brown_wool": "பிரவுன் கம்பளி",
  "block.minecraft.green_wool": "பச்சை கம்பளி",
  "block.minecraft.red_wool": "சிவப்பு கம்பளி",
  "block.minecraft.black_wool": "கருப்பு கம்பளி",
  "block.minecraft.dandelion": "டேன்டேலியன்",
  "block.minecraft.poppy": "பாப்பி",
  "block.minecraft.blue_orchid": "ப்ளூ ஆர்ச்சிட்",
  "block.minecraft.allium": "அல்லியம்",
  "block.minecraft.azure_bluet": "அசோர் ப்ளூட்",
  "block.minecraft.red_tulip": "சிவப்பு துலிப்",
  "block.minecraft.orange_tulip": "ஆரஞ்சு துலிப்",
  "block.minecraft.white_tulip": "வெள்ளை துலிப்",
  "block.minecraft.pink_tulip": "பிங்க் துலிப்",
  "block.minecraft.oxeye_daisy": "ஒக்ஸே டெய்ஸி",
  "block.minecraft.cornflower": "கான்ஃபிளவர்",
  "block.minecraft.lily_of_the_valley": "பள்ளத்தாக்கு லில்லி",
  "block.minecraft.wither_rose": "வாட் ரோஸ்",
  "block.minecraft.brown_mushroom": "பிரவுன் காளான்",
  "block.minecraft.red_mushroom": "சிவப்பு காளான்",
  "block.minecraft.crimson_fungus": "கிரிம்சன் பூஞ்சை",
  "block.minecraft.warped_fungus": "வார்ப்பட் பூஞ்சை",
  "block.minecraft.crimson_roots": "கிரிம்சன் ரூட்ஸ்",
  "block.minecraft.warped_roots": "திசைதிருப்பப்பட்ட வேர்கள்",
  "block.minecraft.nether_sprouts": "நேதர் முளைகள்",
  "block.minecraft.weeping_vines": "அழுகிற கொடிகள்",
  "block.minecraft.twisting_vines": "முறுக்கு கொடிகள்",
  "block.minecraft.sugar_cane": "கரும்பு",
  "block.minecraft.kelp": "கெல்ப்",
  "block.minecraft.bamboo": "மூங்கில்",
  "block.minecraft.gold_block": "தங்கம் பிளாக்",
  "block.minecraft.iron_block": "இரும்புத் தொகுதி",
  "block.minecraft.oak_slab": "ஓக் ஸ்லாப்",
  "block.minecraft.spruce_slab": "ஸ்ப்ரூஸ் ஸ்லாப்",
  "block.minecraft.birch_slab": "பிர்ச் ஸ்லாப்",
  "block.minecraft.jungle_slab": "ஜங்கிள் ஸ்லாப்",
  "block.minecraft.acacia_slab": "அகாசியா ஸ்லாப்",
  "block.minecraft.dark_oak_slab": "டார்க் ஓக் ஸ்லாப்",
  "block.minecraft.crimson_slab": "கிரிம்சன் ஸ்லாப்",
  "block.minecraft.warped_slab": "வார்ப் ஸ்லாப்",
  "block.minecraft.stone_slab": "ஸ்டோன் ஸ்லாப்",
  "block.minecraft.smooth_stone_slab": "மென்மையான ஸ்டோன் ஸ்லாப்",
  "block.minecraft.sandstone_slab": "சாண்ட்ஸ்டோன் ஸ்லாப்",
  "block.minecraft.cut_sandstone_slab": "சாண்ட்ஸ்டோன் ஸ்லாப் வெட்டு",
  "block.minecraft.petrified_oak_slab": "பேபிஃபிட் ஓக் ஸ்லாப்",
  "block.minecraft.cobblestone_slab": "கோபல்ஸ்டோன் ஸ்லாப்",
  "block.minecraft.brick_slab": "செங்கல் ஸ்லாப்",
  "block.minecraft.stone_brick_slab": "ஸ்டோன் பிரிக் ஸ்லாப்",
  "block.minecraft.nether_brick_slab": "நெதர் ப்ரிக் ஸ்லாப்",
  "block.minecraft.quartz_slab": "குவார்ட்ஸ் ஸ்லாப்",
  "block.minecraft.red_sandstone_slab": "ரெட் சாண்ட்ஸ்டோன் ஸ்லாப்",
  "block.minecraft.cut_red_sandstone_slab": "சிவப்பு மணற்கல் கல்லின் அடி",
  "block.minecraft.purpur_slab": "புர்பூர் ஸ்லாப்",
  "block.minecraft.prismarine_slab": "ப்ரிஸ்மரைன் ஸ்லாப்",
  "block.minecraft.prismarine_brick_slab": "பிரைசரைன் பிரிக் ஸ்லாப்",
  "block.minecraft.dark_prismarine_slab": "டார்க் பிரைசரைன் ஸ்லாப்",
  "block.minecraft.smooth_quartz": "மென்மையான குவார்ட்ஸ் தொகுதி",
  "block.minecraft.smooth_red_sandstone": "மென்மையான சிவப்பு மணற்கல்",
  "block.minecraft.smooth_sandstone": "மென்மையான மணல்",
  "block.minecraft.smooth_stone": "மென்மையான கல்",
  "block.minecraft.bricks": "செங்கல்கள்",
  "block.minecraft.tnt": "டிஎன்டி",
  "block.minecraft.bookshelf": "புக்செல்ஃப்",
  "block.minecraft.mossy_cobblestone": "மோஸ்ஸி உருளைக்கல்",
  "block.minecraft.obsidian": "ஒபசிடியன் ஸ்டோன்",
  "block.minecraft.torch": "ஜோதி",
  "block.minecraft.end_rod": "முடிவு ராட்",
  "block.minecraft.chorus_plant": "கோரஸ் ஆலை",
  "block.minecraft.chorus_flower": "கோரஸ் ப்ளூ",
  "block.minecraft.purpur_block": "புர்பூர் பிளாக்",
  "block.minecraft.purpur_pillar": "புர்பூர் தூண்",
  "block.minecraft.purpur_stairs": "புருபூர் மாடி",
  "block.minecraft.spawner": "ஸ்பான்",
  "block.minecraft.oak_stairs": "ஓக் மாடி",
  "block.minecraft.chest": "மார்பு",
  "block.minecraft.diamond_ore": "டயமண்ட் ஓரே",
  "block.minecraft.diamond_block": "டயமண்ட் பிளாக்",
  "block.minecraft.crafting_table": "கைவினை அட்டவணை",
  "block.minecraft.farmland": "விவசாய நிலத்தை",
  "block.minecraft.furnace": "சூளை",
  "block.minecraft.ladder": "லேடர்",
  "block.minecraft.rail": "ரயில்",
  "block.minecraft.cobblestone_stairs": "கோபல்ஸ்டோன் மாடிகளில்",
  "block.minecraft.lever": "லீவர்",
  "block.minecraft.stone_pressure_plate": "கல் அழுத்தம் தட்டு",
  "block.minecraft.oak_pressure_plate": "ஓக் அழுத்தம் தட்டு",
  "block.minecraft.spruce_pressure_plate": "ஸ்ப்ரூஸ் அழுத்தம் தட்டு",
  "block.minecraft.birch_pressure_plate": "பிர்ச் அழுத்தம் தட்டு",
  "block.minecraft.jungle_pressure_plate": "ஜங்கிள் அழுத்தம் தட்டு",
  "block.minecraft.acacia_pressure_plate": "அக்ஸாரியா அழுத்தம் தட்டு",
  "block.minecraft.dark_oak_pressure_plate": "டார்க் ஓக் அழுத்தம் தட்டு",
  "block.minecraft.crimson_pressure_plate": "கிரிம்சன் பிரஷர் பிளேட்",
  "block.minecraft.warped_pressure_plate": "வார்ப் பிரஷர் பிளேட்",
  "block.minecraft.polished_blackstone_pressure_plate": "மெருகூட்டப்பட்ட பிளாக்ஸ்டோன் பிரஷர் பிளேட்",
  "block.minecraft.redstone_ore": "ரெட்ஸ்டோன் ஓரே",
  "block.minecraft.redstone_torch": "ரெட்ஸ்டோன் டார்ச்",
  "block.minecraft.snow": "ஸ்னோ",
  "block.minecraft.ice": "ஐஸ்",
  "block.minecraft.snow_block": "பனி தடுப்பு",
  "block.minecraft.cactus": "கற்றாழை",
  "block.minecraft.clay": "களிமண்",
  "block.minecraft.jukebox": "ஜூக்பாக்ஸ்",
  "block.minecraft.oak_fence": "ஓக் ஃபென்ஸ்",
  "block.minecraft.spruce_fence": "ஸ்ப்ரூஸ் ஃபென்ஸ்",
  "block.minecraft.birch_fence": "பிர்ச் வேலி",
  "block.minecraft.jungle_fence": "ஜங்கிள் வேலி",
  "block.minecraft.acacia_fence": "அகாசி வேலி",
  "block.minecraft.dark_oak_fence": "டார்க் ஓக் ஃபென்ஸ்",
  "block.minecraft.crimson_fence": "கிரிம்சன் வேலி",
  "block.minecraft.warped_fence": "திசைதிருப்பப்பட்ட வேலி",
  "block.minecraft.pumpkin": "பூசணிக்காய்",
  "block.minecraft.carved_pumpkin": "செதுக்கப்பட்ட பூசணி",
  "block.minecraft.netherrack": "நரகத்தின் பாறை",
  "block.minecraft.soul_sand": "சோல் மணல்",
  "block.minecraft.soul_soil": "ஆத்மா மண்",
  "block.minecraft.basalt": "பசால்ட்",
  "block.minecraft.polished_basalt": "பளபளப்பான கருங்கல்",
  "block.minecraft.soul_torch": "சோல் டார்ச்",
  "block.minecraft.glowstone": "ஒளி கல்",
  "block.minecraft.jack_o_lantern": "ஜாக் ஓ'லாந்தர்ன்",
  "block.minecraft.oak_trapdoor": "ஓக் ட்ராபர்டு",
  "block.minecraft.spruce_trapdoor": "ஸ்ப்ரூஸ் ட்ராபர்டு",
  "block.minecraft.birch_trapdoor": "பிர்ச் டிராபூர்",
  "block.minecraft.jungle_trapdoor": "ஜங்கிள் டிராபூர்",
  "block.minecraft.acacia_trapdoor": "அகாசியா ட்ராபர்டு",
  "block.minecraft.dark_oak_trapdoor": "டார்க் ஓக் ட்ராபர்டு",
  "block.minecraft.crimson_trapdoor": "கிரிம்சன் டிராப்டூர்",
  "block.minecraft.warped_trapdoor": "வார்ப் டிராப்டோர்",
  "block.minecraft.infested_stone": "இன்ஸ்டஸ்ட் ஸ்டோன்",
  "block.minecraft.infested_cobblestone": "பாதிக்கப்பட்ட உருளைக்கல்",
  "block.minecraft.infested_stone_bricks": "இன்ஸ்ட்டெட் ஸ்டோன் பிரிக்ஸ்",
  "block.minecraft.infested_mossy_stone_bricks": "பாதிக்கப்பட்ட மோஸ்ஸி கல் செங்கல்கள்",
  "block.minecraft.infested_cracked_stone_bricks": "உள்ளார்ந்த கிராக் ஸ்டோன் பிரிக்ஸ்",
  "block.minecraft.infested_chiseled_stone_bricks": "உட்செலுத்தப்பட்ட கல் வெட்டப்பட்ட செங்கற்கள்",
  "block.minecraft.stone_bricks": "கல் செங்கல்கள்",
  "block.minecraft.mossy_stone_bricks": "மோசி ஸ்டோன் பிரிக்ஸ்",
  "block.minecraft.cracked_stone_bricks": "கிராக் ஸ்டோன் பிரிக்ஸ்",
  "block.minecraft.chiseled_stone_bricks": "சிசிடல் ஸ்டோன் பிரிக்ஸ்",
  "block.minecraft.brown_mushroom_block": "பிரவுன் காளான் பிளாக்",
  "block.minecraft.red_mushroom_block": "சிவப்பு மஷ்ரூம் பிளாக்",
  "block.minecraft.mushroom_stem": "காளான் தண்டு",
  "block.minecraft.iron_bars": "இரும்பு பார்கள்",
  "block.minecraft.chain": "செயின்",
  "block.minecraft.glass_pane": "கண்ணாடி பேன்",
  "block.minecraft.melon": "முலாம்பழம்",
  "block.minecraft.vine": "கொடிகள்",
  "block.minecraft.oak_fence_gate": "ஓக் வேலி கேட்",
  "block.minecraft.spruce_fence_gate": "ஸ்ப்ரூஸ் வேலி கேட்",
  "block.minecraft.birch_fence_gate": "பிர்ச் வேலி கேட்",
  "block.minecraft.jungle_fence_gate": "ஜங்கிள் ஃபென்ஸ் கேட்",
  "block.minecraft.acacia_fence_gate": "அகாசி வேலி நுழைவாயில்",
  "block.minecraft.dark_oak_fence_gate": "டார்க் ஓக் வேலி கேட்",
  "block.minecraft.crimson_fence_gate": "கிரிம்சன் வேலி வாயில்",
  "block.minecraft.warped_fence_gate": "திசைதிருப்பப்பட்ட வேலி வாயில்",
  "block.minecraft.brick_stairs": "செங்கல் மாடி",
  "block.minecraft.stone_brick_stairs": "கல் செங்கல் மாடி",
  "block.minecraft.mycelium": "பூசண",
  "block.minecraft.lily_pad": "லில்லி பேட்",
  "block.minecraft.nether_bricks": "நெதர்லாந்து பிரிக்ஸ்",
  "block.minecraft.cracked_nether_bricks": "கிராக் செய்யப்பட்ட நேதர் செங்கற்கள்",
  "block.minecraft.chiseled_nether_bricks": "வெட்டப்பட்ட நேதர் செங்கற்கள்",
  "block.minecraft.nether_brick_fence": "நெதர்லாந்து செங்கல் வேலி",
  "block.minecraft.nether_brick_stairs": "நெதர்லாந்து செங்கல் மாடி",
  "block.minecraft.enchanting_table": "மயக்கும் அட்டவணை",
  "block.minecraft.end_portal_frame": "இறுதி வலைத் தளம்",
  "block.minecraft.end_stone": "முடிவு கல்",
  "block.minecraft.end_stone_bricks": "முடிவு கல் செங்கல்கள்",
  "block.minecraft.dragon_egg": "டிராகன் முட்டை",
  "block.minecraft.redstone_lamp": "ரெட்ஸ்டோன் லேம்ப்",
  "block.minecraft.sandstone_stairs": "மணல் மாடி",
  "block.minecraft.emerald_ore": "எமரால்டு தாது",
  "block.minecraft.ender_chest": "எண்டர் செஸ்ட்",
  "block.minecraft.tripwire_hook": "ட்ரிப்வைர் ஹூக்",
  "block.minecraft.emerald_block": "எமரால்டு தடுப்பு",
  "block.minecraft.spruce_stairs": "ஸ்ப்ரூஸ் மாடிகளில்",
  "block.minecraft.birch_stairs": "பிர்ச் படிக்கட்டுகள்",
  "block.minecraft.jungle_stairs": "ஜங்கிள் மாடி",
  "block.minecraft.crimson_stairs": "கிரிம்சன் படிக்கட்டுகள்",
  "block.minecraft.warped_stairs": "திசைதிருப்பப்பட்ட படிக்கட்டுகள்",
  "block.minecraft.command_block": "கட்டளைத் தொகுதி",
  "block.minecraft.beacon": "பெக்கான்",
  "block.minecraft.cobblestone_wall": "கோபல்ஸ்டோன் வோல்",
  "block.minecraft.mossy_cobblestone_wall": "மோஸி கோப்ஸ்டோன் சுவர்",
  "block.minecraft.brick_wall": "செங்கல் சுவர்",
  "block.minecraft.prismarine_wall": "ப்ரிஸ்ரைன் வால்",
  "block.minecraft.red_sandstone_wall": "சிவப்பு மணற்கல் சுவர்",
  "block.minecraft.mossy_stone_brick_wall": "மோசி ஸ்டோன் செங்கல் சுவர்",
  "block.minecraft.granite_wall": "கிரானைட் வால்",
  "block.minecraft.stone_brick_wall": "கல் செங்கல் சுவர்",
  "block.minecraft.nether_brick_wall": "நெதர்லாந்து செங்கல் சுவர்",
  "block.minecraft.andesite_wall": "ஆண்டிசைட் வால்",
  "block.minecraft.red_nether_brick_wall": "சிவப்பு செங்கல் சுவர்",
  "block.minecraft.sandstone_wall": "மணல் வால்",
  "block.minecraft.end_stone_brick_wall": "முடிவு கல் செங்கல் சுவர்",
  "block.minecraft.diorite_wall": "தியரிட் வோல்",
  "block.minecraft.blackstone_wall": "கருப்புக்கல் சுவர்",
  "block.minecraft.polished_blackstone_wall": "மெருகூட்டப்பட்ட பிளாக்ஸ்டோன் சுவர்",
  "block.minecraft.polished_blackstone_brick_wall": "மெருகேற்றப்பட்ட கருப்புக்கல் செங்கல் சுவர்",
  "block.minecraft.stone_button": "ஸ்டோன் பட்டன்",
  "block.minecraft.oak_button": "ஓக் பட்டன்",
  "block.minecraft.spruce_button": "ஸ்ப்ரூஸ் பட்டன்",
  "block.minecraft.birch_button": "பிர்ச் பட்டன்",
  "block.minecraft.jungle_button": "ஜங்கிள் பட்டன்",
  "block.minecraft.acacia_button": "அகாசி பட்டன்",
  "block.minecraft.dark_oak_button": "டார்க் ஓக் பட்டன்",
  "block.minecraft.crimson_button": "கிரிம்சன் பட்டன்",
  "block.minecraft.warped_button": "வார்ப்பட் பட்டன்",
  "block.minecraft.polished_blackstone_button": "மெருகூட்டப்பட்ட பிளாக்ஸ்டோன் பொத்தான்",
  "block.minecraft.anvil": "பட்டறை",
  "block.minecraft.chipped_anvil": "முட்டாள் அன்வில்",
  "block.minecraft.damaged_anvil": "சேதமடைந்த அன்வில்",
  "block.minecraft.trapped_chest": "சிக்கிய மார்பு",
  "block.minecraft.light_weighted_pressure_plate": "லேசான எடை கொண்ட அழுத்தம் தட்டு",
  "block.minecraft.heavy_weighted_pressure_plate": "கனரக எடை அழுத்த அழுத்தம்",
  "block.minecraft.daylight_detector": "பகல் கண்டறிதல்",
  "block.minecraft.redstone_block": "சிவப்பு கல் தொகுதி",
  "block.minecraft.nether_quartz_ore": "நெதர்லாந்தின் குவார்ட்ஸ்",
  "block.minecraft.hopper": "ஹாப்பர்",
  "block.minecraft.chiseled_quartz_block": "சிசல்ட் குவார்ட்ஸ் பிளாக்",
  "block.minecraft.quartz_block": "குவார்ட்ஸ் பிளாக்",
  "block.minecraft.quartz_bricks": "குவார்ட்ஸ் செங்கற்கள்",
  "block.minecraft.quartz_pillar": "குவார்ட்ஸ் தூண்",
  "block.minecraft.quartz_stairs": "குவார்ட்ஸ் படிக்கட்டுகள்",
  "block.minecraft.activator_rail": "செயல்பாட்டாளர் ரயில்",
  "block.minecraft.dropper": "துளிசொட்டி",
  "block.minecraft.white_terracotta": "வெள்ளை டெர்ராகோட்டா",
  "block.minecraft.orange_terracotta": "ஆரஞ்சு டெர்ராகோட்டா",
  "block.minecraft.magenta_terracotta": "மெஜந்த டெர்ராகோட்டா",
  "block.minecraft.light_blue_terracotta": "ஒளி ப்ளூ டெர்ராகோட்டா",
  "block.minecraft.yellow_terracotta": "மஞ்சள் டெர்ராகோட்டா",
  "block.minecraft.lime_terracotta": "எலுமிச்சை டெர்ராகோட்டா",
  "block.minecraft.pink_terracotta": "பிங்க் டெர்ராகோட்டா",
  "block.minecraft.gray_terracotta": "சாம்பல் டெர்ராகோட்டா",
  "block.minecraft.light_gray_terracotta": "ஒளி சாம்பல் டெர்ராகோட்டா",
  "block.minecraft.cyan_terracotta": "சியான் டெர்ராகோட்டா",
  "block.minecraft.purple_terracotta": "ஊதா டெர்ராகோட்டா",
  "block.minecraft.blue_terracotta": "ப்ளூ டெர்ராகோட்டா",
  "block.minecraft.brown_terracotta": "பிரவுன் டெர்ராகோட்டா",
  "block.minecraft.green_terracotta": "பச்சை டெர்ராகோட்டா",
  "block.minecraft.red_terracotta": "ரெட் டெர்ரகோட்டா",
  "block.minecraft.black_terracotta": "கருப்பு டெர்ரகோட்டா",
  "block.minecraft.barrier": "தடை",
  "block.minecraft.iron_trapdoor": "அயன் ட்ராபர்டு",
  "block.minecraft.hay_block": "ஹே பேல்",
  "block.minecraft.white_carpet": "வெள்ளை கம்பளம்",
  "block.minecraft.orange_carpet": "ஆரஞ்சு கார்பெட்",
  "block.minecraft.magenta_carpet": "மெஜந்தா கார்பெட்",
  "block.minecraft.light_blue_carpet": "லைட் ப்ளூ கார்பெட்",
  "block.minecraft.yellow_carpet": "மஞ்சள் கம்பளம்",
  "block.minecraft.lime_carpet": "சுண்ணாம்பு கம்பளம்",
  "block.minecraft.pink_carpet": "பிங்க் கார்பெட்",
  "block.minecraft.gray_carpet": "சாம்பல் கம்பளம்",
  "block.minecraft.light_gray_carpet": "ஒளி சாம்பல் கம்பளம்",
  "block.minecraft.cyan_carpet": "சியான் கார்பெட்",
  "block.minecraft.purple_carpet": "ஊதா நிற கம்பளம்",
  "block.minecraft.blue_carpet": "ப்ளூ கார்பெட்",
  "block.minecraft.brown_carpet": "பிரவுன் கார்பெட்",
  "block.minecraft.green_carpet": "பச்சை கம்பளம்",
  "block.minecraft.red_carpet": "சிவப்பு கம்பளம்",
  "block.minecraft.black_carpet": "பிளாக் கார்பெட்",
  "block.minecraft.terracotta": "சிவப்பாய்",
  "block.minecraft.coal_block": "நிலக்கரி பிளாக்",
  "block.minecraft.packed_ice": "பேக் ஐஸ்",
  "block.minecraft.acacia_stairs": "அகாசி ஸ்டேர்ஸ்",
  "block.minecraft.dark_oak_stairs": "டார்க் ஓக் மாடி",
  "block.minecraft.slime_block": "மெல்லிய பிளாக்",
  "block.minecraft.grass_path": "புல் பாத்",
  "block.minecraft.sunflower": "சூரியகாந்தி",
  "block.minecraft.lilac": "இளஞ்சிவப்பு",
  "block.minecraft.rose_bush": "ரோஸ் புஷ்",
  "block.minecraft.peony": "பியோனி",
  "block.minecraft.tall_grass": "உயரமான புல்",
  "block.minecraft.large_fern": "பெரிய பெர்ன்",
  "block.minecraft.white_stained_glass": "வெள்ளை கறை படிந்த கண்ணாடி",
  "block.minecraft.orange_stained_glass": "ஆரஞ்சு கறை படிந்த கண்ணாடி",
  "block.minecraft.magenta_stained_glass": "மெஜந்தா கறை படிந்த கண்ணாடி",
  "block.minecraft.light_blue_stained_glass": "ஒளி நீல கறை படிந்த கண்ணாடி",
  "block.minecraft.yellow_stained_glass": "மஞ்சள் கறை படிந்த கண்ணாடி",
  "block.minecraft.lime_stained_glass": "எலுமிச்சை கறை படிந்த கண்ணாடி",
  "block.minecraft.pink_stained_glass": "பிங்க் கறை படிந்த கண்ணாடி",
  "block.minecraft.gray_stained_glass": "சாம்பல் நிற கண்ணாடி",
  "block.minecraft.light_gray_stained_glass": "ஒளி சாம்பல் நிற கண்ணாடி",
  "block.minecraft.cyan_stained_glass": "சியான் கறை படிந்த கண்ணாடி",
  "block.minecraft.purple_stained_glass": "ஊதா கறை படிந்த கண்ணாடி",
  "block.minecraft.blue_stained_glass": "நீல கறை படிந்த கண்ணாடி",
  "block.minecraft.brown_stained_glass": "பிரவுன் கறை படிந்த கண்ணாடி",
  "block.minecraft.green_stained_glass": "பசுமை கறை படிந்த கண்ணாடி",
  "block.minecraft.red_stained_glass": "சிவப்பு நிற கண்ணாடி",
  "block.minecraft.black_stained_glass": "பிளாக் கறைபடிந்த கண்ணாடி",
  "block.minecraft.white_stained_glass_pane": "வெள்ளை கறை படிந்த கண்ணாடி தகடு",
  "block.minecraft.orange_stained_glass_pane": "ஆரஞ்சு படிந்த கண்ணாடி தகடு",
  "block.minecraft.magenta_stained_glass_pane": "மெஜந்தா படிந்த கண்ணாடி பேன்",
  "block.minecraft.light_blue_stained_glass_pane": "லைட் ப்ளூ ஸ்டேன்ட் கண்ணாடி பேன்",
  "block.minecraft.yellow_stained_glass_pane": "மஞ்சள் படிந்த கண்ணாடி பேன்",
  "block.minecraft.lime_stained_glass_pane": "சுண்ணாம்பு படிந்த கண்ணாடி தகடு",
  "block.minecraft.pink_stained_glass_pane": "பிங்க் கறைபடிந்த கண்ணாடி தகடு",
  "block.minecraft.gray_stained_glass_pane": "சாம்பல் நிற கண்ணாடி கண்ணாடி",
  "block.minecraft.light_gray_stained_glass_pane": "லைட் கிரே ஸ்டைண்ட்டு கண்ணாடி பேன்",
  "block.minecraft.cyan_stained_glass_pane": "சியான் படிந்த கண்ணாடி பேன்",
  "block.minecraft.purple_stained_glass_pane": "ஊதா படிந்த கண்ணாடி பேன்",
  "block.minecraft.blue_stained_glass_pane": "நீல நிற கண்ணாடி கண்ணாடி",
  "block.minecraft.brown_stained_glass_pane": "பிரவுன் கறை படிந்த கண்ணாடி தகடு",
  "block.minecraft.green_stained_glass_pane": "பசுமை படிந்த கண்ணாடி தகடு",
  "block.minecraft.red_stained_glass_pane": "சிவப்பு நிற கண்ணாடி கண்ணாடி",
  "block.minecraft.black_stained_glass_pane": "பிளாக் ஸ்டென்னை கண்ணாடி பேன்",
  "block.minecraft.prismarine": "ப்ரிஸ்டார்ன்",
  "block.minecraft.prismarine_bricks": "ப்ரிஸ்டார்ன் பிரிக்ஸ்",
  "block.minecraft.dark_prismarine": "டார்க் பிரைசரைன்",
  "block.minecraft.prismarine_stairs": "ப்ரீஸ்மரைன் மாடி",
  "block.minecraft.prismarine_brick_stairs": "பிரைசரைன் செங்கல் மாடி",
  "block.minecraft.dark_prismarine_stairs": "டார்க் பிரைசரைன் மாடிப்படி",
  "block.minecraft.sea_lantern": "கடல் விளக்கு",
  "block.minecraft.red_sandstone": "சிவப்பு மணற்கல்",
  "block.minecraft.chiseled_red_sandstone": "சிவப்பு மணற்கல்",
  "block.minecraft.cut_red_sandstone": "சிவப்பு மணற்கல் வெட்டு",
  "block.minecraft.red_sandstone_stairs": "சிவப்பு மணற்கல் மாடி",
  "block.minecraft.repeating_command_block": "கட்டளை தொகுதி மீண்டும் மீண்டும்",
  "block.minecraft.chain_command_block": "சங்கிலி கட்டளைத் தொகுதி",
  "block.minecraft.magma_block": "மாக்மா பிளாக்",
  "block.minecraft.nether_wart_block": "நெதர் வொர்க் பிளாக்",
  "block.minecraft.warped_wart_block": "வார்ப் வார்ட் பிளாக்",
  "block.minecraft.red_nether_bricks": "ரெட் நெதர் பிரிக்ஸ்",
  "block.minecraft.bone_block": "எலும்பு பிளாக்",
  "block.minecraft.structure_void": "அமைப்பு வெற்றிடத்தை",
  "block.minecraft.observer": "அப்சர்வர்",
  "block.minecraft.shulker_box": "ஷுல்கர் பெட்டி",
  "block.minecraft.white_shulker_box": "வெள்ளை ஷுல்கர் பெட்டி",
  "block.minecraft.orange_shulker_box": "ஆரஞ்சு ஷூல்கர் பெட்டி",
  "block.minecraft.magenta_shulker_box": "மெஜந்த ஷுல்கர் பெட்டி",
  "block.minecraft.light_blue_shulker_box": "லைட் ப்ளூ ஷுல்கர் பாக்ஸ்",
  "block.minecraft.yellow_shulker_box": "மஞ்சள் ஷல்கர் பெட்டி",
  "block.minecraft.lime_shulker_box": "சுண்ணாம்பு சுருள் பெட்டி",
  "block.minecraft.pink_shulker_box": "பிங்க் ஷுல்கர் பெட்டி",
  "block.minecraft.gray_shulker_box": "சாம்பல் ஷுல்கர் பெட்டி",
  "block.minecraft.light_gray_shulker_box": "ஒளி சாம்பல் ஷுல்கர் பெட்டி",
  "block.minecraft.cyan_shulker_box": "சியான் ஷுல்கர் பெட்டி",
  "block.minecraft.purple_shulker_box": "ஊதா ஷூல்கர் பெட்டி",
  "block.minecraft.blue_shulker_box": "ப்ளூ ஷுல்கர் பெட்டி",
  "block.minecraft.brown_shulker_box": "பிரவுன் ஷுல்கர் பெட்டி",
  "block.minecraft.green_shulker_box": "பச்சை ஷூல்கர் பெட்டி",
  "block.minecraft.red_shulker_box": "சிவப்பு ஷெல்கர் பெட்டி",
  "block.minecraft.black_shulker_box": "பிளாக் ஷுல்கர் பெட்டி",
  "block.minecraft.white_glazed_terracotta": "வெள்ளை பளபளப்பான டெர்ராகோட்டா",
  "block.minecraft.orange_glazed_terracotta": "ஆரஞ்சு பளபளப்பான டெர்ராகோட்டா",
  "block.minecraft.magenta_glazed_terracotta": "மெஜந்தா பளபளப்பான டெர்ராகோட்டா",
  "block.minecraft.light_blue_glazed_terracotta": "லைட் ப்ளூ பளபளப்பான டெர்ராகோட்டா",
  "block.minecraft.yellow_glazed_terracotta": "மஞ்சள் பளபளப்பான டெர்ராகோட்டா",
  "block.minecraft.lime_glazed_terracotta": "சுண்ணாம்பு பளபளப்பான டெர்ராக்கோட்டா",
  "block.minecraft.pink_glazed_terracotta": "பிங்க் மெழுகுவர்த்தி டெர்ராகோட்டா",
  "block.minecraft.gray_glazed_terracotta": "சாம்பல் பளபளப்பான டெர்ராகோட்டா",
  "block.minecraft.light_gray_glazed_terracotta": "லைட் சாம்பல் பளபளப்பான டெர்ராக்கோட்டா",
  "block.minecraft.cyan_glazed_terracotta": "சியான் கிளேசட் டெர்ராகோட்டா",
  "block.minecraft.purple_glazed_terracotta": "ஊதா மெழுகுவர்த்தி டெர்ராகோட்டா",
  "block.minecraft.blue_glazed_terracotta": "நீல மெருகூட்டப்பட்ட டெர்ராக்கோட்டா",
  "block.minecraft.brown_glazed_terracotta": "நீல மெருகூட்டப்பட்ட டெர்ராக்கோட்டா",
  "block.minecraft.green_glazed_terracotta": "பச்சை மெருகூட்டப்பட்ட டெர்ராக்கோட்டா",
  "block.minecraft.red_glazed_terracotta": "சிவப்பு மெருகூட்டப்பட்ட டெர்ராக்கோட்டா",
  "block.minecraft.black_glazed_terracotta": "கருப்பு மெருகூட்டப்பட்ட டெர்ராக்கோட்டா",
  "block.minecraft.white_concrete": "வெள்ளை கான்கிரீட்",
  "block.minecraft.orange_concrete": "ஆரஞ்சு கான்கிரீட்",
  "block.minecraft.magenta_concrete": "மெஜந்தா கான்கிரீட்",
  "block.minecraft.light_blue_concrete": "ஒளி ப்ளூ கான்கிரீட்",
  "block.minecraft.yellow_concrete": "மஞ்சள் கான்கிரீட்",
  "block.minecraft.lime_concrete": "எலுமிச்சை கான்கிரீட்",
  "block.minecraft.pink_concrete": "பிங்க் கான்கிரீட்",
  "block.minecraft.gray_concrete": "சாம்பல் கான்கிரீட்",
  "block.minecraft.light_gray_concrete": "ஒளி சாம்பல் கான்கிரீட்",
  "block.minecraft.cyan_concrete": "சயன் கான்கிரீட்",
  "block.minecraft.purple_concrete": "ஊதா கான்கிரீட்",
  "block.minecraft.blue_concrete": "ப்ளூ கான்கிரீட்",
  "block.minecraft.brown_concrete": "பிரவுன் கான்கிரீட்",
  "block.minecraft.green_concrete": "பச்சை கான்கிரீட்",
  "block.minecraft.red_concrete": "சிவப்பு கான்கிரீட்",
  "block.minecraft.black_concrete": "கருப்பு கான்கிரீட்",
  "block.minecraft.white_concrete_powder": "வெள்ளை கான்கிரீட் தூள்",
  "block.minecraft.orange_concrete_powder": "ஆரஞ்சு கான்கிரீட் தூள்",
  "block.minecraft.magenta_concrete_powder": "மெஜந்தா கான்கிரீட் தூள்",
  "block.minecraft.light_blue_concrete_powder": "லைட் ப்ளூ கான்கிரீட் தூள்",
  "block.minecraft.yellow_concrete_powder": "மஞ்சள் கான்கிரீட் தூள்",
  "block.minecraft.lime_concrete_powder": "சுண்ணாம்பு கான்கிரீட் தூள்",
  "block.minecraft.pink_concrete_powder": "பிங்க் கான்கிரீட் தூள்",
  "block.minecraft.gray_concrete_powder": "சாம்பல் கான்கிரீட் தூள்",
  "block.minecraft.light_gray_concrete_powder": "ஒளி சாம்பல் கான்கிரீட் தூள்",
  "block.minecraft.cyan_concrete_powder": "சியான் கான்கிரீட் தூள்",
  "block.minecraft.purple_concrete_powder": "ஊதா கான்கிரீட் தூள்",
  "block.minecraft.blue_concrete_powder": "நீல கான்கிரீட் தூள்",
  "block.minecraft.brown_concrete_powder": "பிரவுன் கான்கிரீட் தூள்",
  "block.minecraft.green_concrete_powder": "பச்சை கான்கிரீட் தூள்",
  "block.minecraft.red_concrete_powder": "சிவப்பு கான்கிரீட் தூள்",
  "block.minecraft.black_concrete_powder": "கருப்பு கான்கிரீட் தூள்",
  "block.minecraft.turtle_egg": "ஆமை முட்டை",
  "block.minecraft.dead_tube_coral_block": "டெட் குழாய் கோரல் பிளாக்",
  "block.minecraft.dead_brain_coral_block": "இறந்த மூளை கோரல் பிளாக்",
  "block.minecraft.dead_bubble_coral_block": "இறந்த குமிழ் கோரல் பிளாக்",
  "block.minecraft.dead_fire_coral_block": "டெட் ஃபயர் கோரல் பிளாக்",
  "block.minecraft.dead_horn_coral_block": "டெட் ஹார்ன் கொரல் பிளாக்",
  "block.minecraft.tube_coral_block": "குழாய் கோரல் பிளாக்",
  "block.minecraft.brain_coral_block": "மூளை கோரல் பிளாக்",
  "block.minecraft.bubble_coral_block": "பபுள் கோரல் பிளாக்",
  "block.minecraft.fire_coral_block": "தீ கோரல் பிளாக்",
  "block.minecraft.horn_coral_block": "ஹார்ன் கோரல் பிளாக்",
  "block.minecraft.tube_coral": "குழாய் பவள",
  "block.minecraft.brain_coral": "மூளை கோரல்",
  "block.minecraft.bubble_coral": "பபுள் கோரல்",
  "block.minecraft.fire_coral": "தீ கோரல்",
  "block.minecraft.horn_coral": "ஹார்ன் கோரல்",
  "block.minecraft.dead_brain_coral": "இறந்த மூளை கோரல்",
  "block.minecraft.dead_bubble_coral": "இறந்த குமிழ் கோரல்",
  "block.minecraft.dead_fire_coral": "டெட் ஃபயர் கோரல்",
  "block.minecraft.dead_horn_coral": "டெட் ஹார்ன் கோரல்",
  "block.minecraft.dead_tube_coral": "டெட் குழாய் கோரல்",
  "block.minecraft.tube_coral_fan": "குழி பவள ஃபேன்",
  "block.minecraft.brain_coral_fan": "மூளை பவள ரசிகர்",
  "block.minecraft.bubble_coral_fan": "பப்பில் கோரல் ரசிகன்",
  "block.minecraft.fire_coral_fan": "தீ கோரல் ரசிகன்",
  "block.minecraft.horn_coral_fan": "ஹார்ன் கோரல் ரசிகன்",
  "block.minecraft.dead_tube_coral_fan": "டெட் குழாய் கோரல் ரசிகன்",
  "block.minecraft.dead_brain_coral_fan": "இறந்த மூளை கோரல் ரசிகன்",
  "block.minecraft.dead_bubble_coral_fan": "இறந்த பபுள் கோரல் ரசிகன்",
  "block.minecraft.dead_fire_coral_fan": "டெட் தீ கோரல் ஃபேன்",
  "block.minecraft.dead_horn_coral_fan": "டெட் ஹார்ன் கோரல் ரசிகன்",
  "block.minecraft.blue_ice": "ப்ளூ ஐஸ்",
  "block.minecraft.conduit": "கால்வாய்",
  "block.minecraft.polished_granite_stairs": "பளபளப்பான கிரானைட் படிக்கட்டுகள்",
  "block.minecraft.smooth_red_sandstone_stairs": "மென்மையான சிவப்பு மணற்கல் மாடி",
  "block.minecraft.mossy_stone_brick_stairs": "மோஸ்ஸி கல் செங்கல் மாடிப்படி",
  "block.minecraft.polished_diorite_stairs": "பளபளப்பான டியோசடங்குடன் படிகள்",
  "block.minecraft.mossy_cobblestone_stairs": "மோஸ்ஸி உருளைக்கல் மாடிப்படி",
  "block.minecraft.end_stone_brick_stairs": "முடிவு கல் செங்கல் மாடி",
  "block.minecraft.stone_stairs": "கல் மாடி",
  "block.minecraft.smooth_sandstone_stairs": "மென்மையான மணற்கல் மாடி",
  "block.minecraft.smooth_quartz_stairs": "மென்மையான குவார்ட்ஸ் மாடிகளில்",
  "block.minecraft.granite_stairs": "கிரானைட் படிக்கட்டுகள்",
  "block.minecraft.andesite_stairs": "ஆண்டிசைட் படிக்கட்டுகள்",
  "block.minecraft.red_nether_brick_stairs": "ரெட் நெதர் செங்கல் மாடி",
  "block.minecraft.polished_andesite_stairs": "பளபளப்பான ஆன்டிசைட் படிக்கட்டுகள்",
  "block.minecraft.diorite_stairs": "கிரானைட் படிக்கட்டுகள்",
  "block.minecraft.polished_granite_slab": "பளபளப்பான கிரானைட் ஸ்லாப்",
  "block.minecraft.smooth_red_sandstone_slab": "மென்மையான சிவப்பு மணற்கல் மாடி",
  "block.minecraft.mossy_stone_brick_slab": "மோசி ஸ்டோன் பிரிக் ஸ்லாப்",
  "block.minecraft.polished_diorite_slab": "பளபளப்பான diorite ஸ்லாப்",
  "block.minecraft.mossy_cobblestone_slab": "மோஸ்ஸி உருளைக்கல் ஸ்லாப்",
  "block.minecraft.end_stone_brick_slab": "முடிவு கல் செங்கல் ஸ்லாப்",
  "block.minecraft.smooth_sandstone_slab": "மென்மையான மணல் ஸ்டாப்",
  "block.minecraft.smooth_quartz_slab": "மென்மையான குவார்ட்ஸ் ஸ்லாப்",
  "block.minecraft.granite_slab": "கிரானைட் ஸ்லாப்",
  "block.minecraft.andesite_slab": "ஆண்டிசைட் ஸ்லாப்",
  "block.minecraft.red_nether_brick_slab": "ரெட் நெதர் ப்ரிக் ஸ்லாப்",
  "block.minecraft.polished_andesite_slab": "பளபளப்பான ஆன்டிசைட் ஸ்லாப்",
  "block.minecraft.diorite_slab": "தியரிட் ஸ்லாப்",
  "block.minecraft.scaffolding": "சாரக்கட்டு",
  "block.minecraft.iron_door": "இரும்பு கதவு",
  "block.minecraft.oak_door": "ஓக் கதவு",
  "block.minecraft.spruce_door": "ஸ்ப்ரூஸ் கதவு",
  "block.minecraft.birch_door": "பிர்ச் டோர்",
  "block.minecraft.jungle_door": "ஜங்கிள் கதவு",
  "block.minecraft.acacia_door": "அகாசியா கதவு",
  "block.minecraft.dark_oak_door": "டார்க் ஓக் கதவு",
  "block.minecraft.crimson_door": "கிரிம்சன் கதவு",
  "block.minecraft.warped_door": "வார்ப் டோர்",
  "block.minecraft.repeater": "ரெட்ஸ்டோன் ரிப்பீட்டர்",
  "block.minecraft.comparator": "ரெட்ஸ்டோன் ஒப்பீட்டாளர்",
  "block.minecraft.structure_block": "கட்டமைப்பு பிளாக்",
  "block.minecraft.jigsaw": "ஜிக் பிளாக்",
  "item.minecraft.turtle_helmet": "ஆமை ஷெல்□□தலையில் இருக்கும்போது:□+2 கவசம்",
  "item.minecraft.scute": "scute",
  "item.minecraft.iron_shovel": "இரும்பு திணி□□முக்கிய கையில் இருக்கும்போது:□+3.5 தாக்குதலால் சேதம்□-3 தாக்குதல் வேகம்",
  "item.minecraft.iron_pickaxe": "இரும்பு பிக்ஸாக்□□முக்கிய கையில் இருக்கும்போது:□+3 தாக்குதலால் சேதம்□-2.8 தாக்குதல் வேகம்",
  "item.minecraft.iron_axe": "இரும்பு கோடாரி□□முக்கிய கையில் இருக்கும்போது:□+8 தாக்குதலால் சேதம்□-3.1 தாக்குதல் வேகம்",
  "item.minecraft.flint_and_steel": "பிளின்ட் மற்றும் ஸ்டீல்",
  "item.minecraft.apple": "ஆப்பிள்",
  "item.minecraft.bow": "வில்",
  "item.minecraft.arrow": "அம்பு",
  "item.minecraft.coal": "நிலக்கரி",
  "item.minecraft.charcoal": "கரி",
  "item.minecraft.diamond": "டயமண்ட்",
  "item.minecraft.iron_ingot": "இரும்பு இங்காட்",
  "item.minecraft.gold_ingot": "தங்க இகோட்",
  "item.minecraft.netherite_ingot": "நெதரைட் இங்காட்",
  "item.minecraft.netherite_scrap": "நெதரைட் ஸ்கிராப்",
  "item.minecraft.iron_sword": "இரும்பு வாள்□□முக்கிய கையில் இருக்கும்போது:□+5 தாக்குதலால் சேதம்□-2.4 தாக்குதல் வேகம்",
  "item.minecraft.wooden_sword": "மர வாள்□□முக்கிய கையில் இருக்கும்போது:□+3 தாக்குதலால் சேதம்□-2.4 தாக்குதல் வேகம்",
  "item.minecraft.wooden_shovel": "மர திணி□□முக்கிய கையில் இருக்கும்போது:□+1.5 தாக்குதலால் சேதம்□-3 தாக்குதல் வேகம்",
  "item.minecraft.wooden_pickaxe": "மர பிக்காக்ஸ்□□முக்கிய கையில் இருக்கும்போது:□+1 தாக்குதலால் சேதம்□-2.8 தாக்குதல் வேகம்",
  "item.minecraft.wooden_axe": "மர அச்சு□□முக்கிய கையில் இருக்கும்போது:□+6 தாக்குதலால் சேதம்□-3.2 தாக்குதல் வேகம்",
  "item.minecraft.stone_sword": "கல் வாள்□□முக்கிய கையில் இருக்கும்போது:□+4 தாக்குதலால் சேதம்□-2.4 தாக்குதல் வேகம்",
  "item.minecraft.stone_shovel": "ஸ்டோன் திணி□□முக்கிய கையில் இருக்கும்போது:□+2.5 தாக்குதலால் சேதம்□-3 தாக்குதல் வேகம்",
  "item.minecraft.stone_pickaxe": "ஸ்டோன் பிக்காக்ஸ்□□முக்கிய கையில் இருக்கும்போது:□+2 தாக்குதலால் சேதம்□-2.8 தாக்குதல் வேகம்",
  "item.minecraft.stone_axe": "கல் அச்சு□□முக்கிய கையில் இருக்கும்போது:□+8 தாக்குதலால் சேதம்□-3.2 தாக்குதல் வேகம்",
  "item.minecraft.diamond_sword": "டயமண்ட் வாள்□□முக்கிய கையில் இருக்கும்போது:□+6 தாக்குதலால் சேதம்□-2.4 தாக்குதல் வேகம்",
  "item.minecraft.diamond_shovel": "டயமண்ட் திணி□□முக்கிய கையில் இருக்கும்போது:□+4.5 தாக்குதலால் சேதம்□-3 தாக்குதல் வேகம்",
  "item.minecraft.diamond_pickaxe": "டயமண்ட் பிக்ஸாக்□□முக்கிய கையில் இருக்கும்போது:□+4 தாக்குதலால் சேதம்□-2.8 தாக்குதல் வேகம்",
  "item.minecraft.diamond_axe": "டயமண்ட் கோடாரி□□முக்கிய கையில் இருக்கும்போது:□+8 தாக்குதலால் சேதம்□-3 தாக்குதல் வேகம்",
  "item.minecraft.stick": "குச்சி",
  "item.minecraft.bowl": "பவுல்",
  "item.minecraft.mushroom_stew": "காளான் குண்டு",
  "item.minecraft.golden_sword": "கோல்டன் வாள்□□முக்கிய கையில் இருக்கும்போது:□+3 தாக்குதலால் சேதம்□-2.4 தாக்குதல் வேகம்",
  "item.minecraft.golden_shovel": "கோல்டன் வெந்தயம்□□முக்கிய கையில் இருக்கும்போது:□+1.5 தாக்குதலால் சேதம்□-3 தாக்குதல் வேகம்",
  "item.minecraft.golden_pickaxe": "கோல்டன் பிக்சே□□முக்கிய கையில் இருக்கும்போது:□+1 தாக்குதலால் சேதம்□-2.8 தாக்குதல் வேகம்",
  "item.minecraft.golden_axe": "கோல்டன் ஆக்ஸ்□□முக்கிய கையில் இருக்கும்போது:□+6 தாக்குதலால் சேதம்□-3 தாக்குதல் வேகம்",
  "item.minecraft.netherite_sword": "நெதரைட் வாள்□□முக்கிய கையில் இருக்கும்போது:□+7 தாக்குதலால் சேதம்□-2.4 தாக்குதல் வேகம்",
  "item.minecraft.netherite_shovel": "நெதரைட் திணி□□முக்கிய கையில் இருக்கும்போது:□+5.5 தாக்குதலால் சேதம்□-3 தாக்குதல் வேகம்",
  "item.minecraft.netherite_pickaxe": "நெதரைட் பிகாக்ஸ்□□முக்கிய கையில் இருக்கும்போது:□+5 தாக்குதலால் சேதம்□-2.8 தாக்குதல் வேகம்",
  "item.minecraft.netherite_axe": "நெதரைட் கோடாரி□□முக்கிய கையில் இருக்கும்போது:□+9 தாக்குதலால் சேதம்□-3 தாக்குதல் வேகம்",
  "item.minecraft.string": "சரம்",
  "item.minecraft.feather": "இறகு",
  "item.minecraft.gunpowder": "வெடிமருந்து",
  "item.minecraft.wooden_hoe": "மரத்தாலான ஹீ□□முக்கிய கையில் இருக்கும்போது:□-3 தாக்குதல் வேகம்",
  "item.minecraft.stone_hoe": "ஸ்டோன் ஹோ□□முக்கிய கையில் இருக்கும்போது:□-2 தாக்குதல் வேகம்",
  "item.minecraft.iron_hoe": "இரும்புத் தாது□□முக்கிய கையில் இருக்கும்போது:□-1 தாக்குதல் வேகம்",
  "item.minecraft.diamond_hoe": "டயமண்ட் ஹோ□□முக்கிய கையில் இருக்கும்போது:",
  "item.minecraft.golden_hoe": "கோல்டன் ஹொ□□முக்கிய கையில் இருக்கும்போது:□-3 தாக்குதல் வேகம்",
  "item.minecraft.netherite_hoe": "நெதரைட் ஹோ□□முக்கிய கையில் இருக்கும்போது:",
  "item.minecraft.wheat_seeds": "கோதுமை விதைகள்",
  "item.minecraft.wheat": "கோதுமை",
  "item.minecraft.bread": "ரொட்டி",
  "item.minecraft.leather_helmet": "தோல் கேப்□□தலையில் இருக்கும்போது:□+1 கவசம்",
  "item.minecraft.leather_chestplate": "தோல் துணி□□உடலில் இருக்கும்போது:□+3 கவசம்",
  "item.minecraft.leather_leggings": "தோல் கால்சட்டைகள்□□கால்களில் இருக்கும்போது:□+2 கவசம்",
  "item.minecraft.leather_boots": "தோல் பூட்ஸ்□□காலில் இருக்கும்போது:□+1 கவசம்",
  "item.minecraft.chainmail_helmet": "சாய்னெயில் ஹெல்மெட்□□தலையில் இருக்கும்போது:□+2 கவசம்",
  "item.minecraft.chainmail_chestplate": "சாப்டர்ஒருநான்என்எம்ஏநான் l மார்புதட்டு□□உடலில் இருக்கும்போது:□+5 கவசம்",
  "item.minecraft.chainmail_leggings": "சாப்டர்ஒருநான்என்எம்ஏநான் l லெக்இல்கிராம்ங்கள்□□கால்களில் இருக்கும்போது:□+4 கவசம்",
  "item.minecraft.chainmail_boots": "சாப்டர்ஒருநான்என்எம்ஏநான் l பூட்ஸ்□□காலில் இருக்கும்போது:□+1 கவசம்",
  "item.minecraft.iron_helmet": "இரும்பு ஹெல்மெட்□□தலையில் இருக்கும்போது:□+2 கவசம்",
  "item.minecraft.iron_chestplate": "இரும்புச் செடி□□உடலில் இருக்கும்போது:□+6 கவசம்",
  "item.minecraft.iron_leggings": "இரும்புச் சட்டை□□கால்களில் இருக்கும்போது:□+5 கவசம்",
  "item.minecraft.iron_boots": "இரும்பு துவாரங்கள்□□காலில் இருக்கும்போது:□+2 கவசம்",
  "item.minecraft.diamond_helmet": "டயமண்ட் ஹெல்மெட்□□தலையில் இருக்கும்போது:□+3 கவசம்□+2 கவச கடினத்தன்மை",
  "item.minecraft.diamond_chestplate": "டயமண்ட் செஸ்ட்டெட்□□உடலில் இருக்கும்போது:□+8 கவசம்□+2 கவச கடினத்தன்மை",
  "item.minecraft.diamond_leggings": "டயமண்ட் லெக்கிங்ஸ்□□கால்களில் இருக்கும்போது:□+6 கவசம்□+2 கவச கடினத்தன்மை",
  "item.minecraft.diamond_boots": "டயமண்ட் பூட்ஸ்□□காலில் இருக்கும்போது:□+3 கவசம்□+2 கவச கடினத்தன்மை",
  "item.minecraft.golden_helmet": "கோல்டன் ஹெல்மெட்□□தலையில் இருக்கும்போது:□+2 கவசம்",
  "item.minecraft.golden_chestplate": "கோல்டன் செஸ்ட் பிளேட்□□உடலில் இருக்கும்போது:□+5 கவசம்",
  "item.minecraft.golden_leggings": "கோல்டன் லெக்கிங்ஸ்□□கால்களில் இருக்கும்போது:□+3 கவசம்",
  "item.minecraft.golden_boots": "கோல்டன் பூட்ஸ்□□காலில் இருக்கும்போது:□+1 கவசம்",
  "item.minecraft.netherite_helmet": "நெதரைட் ஹெல்மெட்□□தலையில் இருக்கும்போது:□+3 கவசம்□+3 கவச கடினத்தன்மை□+1 நாக் பேக் எதிர்ப்பு",
  "item.minecraft.netherite_chestplate": "நெதரைட் செஸ்ட் பிளேட்□□உடலில் இருக்கும்போது:□+8 கவசம்□+3 கவச கடினத்தன்மை□+1 நாக் பேக் எதிர்ப்பு",
  "item.minecraft.netherite_leggings": "நெதரைட் லெகிங்ஸ்□□கால்களில் இருக்கும்போது:□+6 கவசம்□+3 கவச கடினத்தன்மை□+1 நாக் பேக் எதிர்ப்பு",
  "item.minecraft.netherite_boots": "நெதரைட் பூட்ஸ்□□காலில் இருக்கும்போது:□+3 கவசம்□+3 கவச கடினத்தன்மை□+1 நாக் பேக் எதிர்ப்பு",
  "item.minecraft.flint": "பிளின்ட்",
  "item.minecraft.porkchop": "மூல போர்காப்",
  "item.minecraft.cooked_porkchop": "சமைத்த பன்றி இறைச்சி",
  "item.minecraft.painting": "ஓவியம்",
  "item.minecraft.golden_apple": "தங்க ஆப்பிள்",
  "item.minecraft.enchanted_golden_apple": "மந்திரித்த கோல்டன் ஆப்பிள்",
  "block.minecraft.oak_sign": "ஓக் சைன்",
  "block.minecraft.spruce_sign": "ஸ்ப்ரூஸ் சைன்",
  "block.minecraft.birch_sign": "பிர்ச் சைன்",
  "block.minecraft.jungle_sign": "ஜங்கிள் சைன்",
  "block.minecraft.acacia_sign": "அகாசியா சைன்",
  "block.minecraft.dark_oak_sign": "டார்க் ஓக் சைன்",
  "block.minecraft.crimson_sign": "கிரிம்சன் அடையாளம்",
  "block.minecraft.warped_sign": "திசைதிருப்பப்பட்ட அடையாளம்",
  "item.minecraft.bucket": "வாளி",
  "item.minecraft.water_bucket": "நீர் வாளி",
  "item.minecraft.lava_bucket": "லாவா பக்கெட்",
  "item.minecraft.minecart": "வேகன்",
  "item.minecraft.saddle": "சேணம்",
  "item.minecraft.redstone": "ரெட்ஸ்டோன் டஸ்ட்",
  "item.minecraft.snowball": "பனிப்பந்து",
  "item.minecraft.oak_boat": "ஓக் படகு",
  "item.minecraft.leather": "தோல்",
  "item.minecraft.milk_bucket": "பால் பருந்து",
  "item.minecraft.pufferfish_bucket": "பஃபெர்ஃபி ஆஃப் பஃபெர்ஃபி",
  "item.minecraft.salmon_bucket": "சால்மன் வாளி",
  "item.minecraft.cod_bucket": "காட் பக்",
  "item.minecraft.tropical_fish_bucket": "வெப்பமண்டல மீன் வாளி",
  "item.minecraft.brick": "செங்கல்",
  "item.minecraft.clay_ball": "களிமண் பந்து",
  "block.minecraft.dried_kelp_block": "உலர்ந்த கெல்ப் பிளாக்",
  "item.minecraft.paper": "காகிதம்",
  "item.minecraft.book": "புத்தகம்",
  "item.minecraft.slime_ball": "இழிந்த தன்மையுடைய நபர்",
  "item.minecraft.chest_minecart": "மார்போடு மின்கார்ட்",
  "item.minecraft.furnace_minecart": "உலைகளுடன் மின்கார்ட்",
  "item.minecraft.egg": "முட்டை",
  "item.minecraft.compass": "திசைகாட்டி",
  "item.minecraft.fishing_rod": "மீன்பிடி ராட்",
  "item.minecraft.clock": "கடிகாரம்",
  "item.minecraft.glowstone_dust": "க்ளோஸ்டோன் தூசி",
  "item.minecraft.cod": "ரா காட்",
  "item.minecraft.salmon": "மூல சால்மன்",
  "item.minecraft.tropical_fish": "நன்னீர் மீன் வளர்ப்பு",
  "item.minecraft.pufferfish": "பஃபர்ஃபிஷ்",
  "item.minecraft.cooked_cod": "சமைத்த காட்",
  "item.minecraft.cooked_salmon": "சமைத்த சால்மன்",
  "item.minecraft.ink_sac": "மைப்பை",
  "item.minecraft.red_dye": "சிவப்பு சாயம்",
  "item.minecraft.green_dye": "பச்சை சாயம்",
  "item.minecraft.cocoa_beans": "கோகோ பீன்ஸ்",
  "item.minecraft.lapis_lazuli": "லேபிஸ் லாஜூலி",
  "item.minecraft.purple_dye": "ஊதா சாயம்",
  "item.minecraft.cyan_dye": "சியான் சாய்",
  "item.minecraft.light_gray_dye": "ஒளி சாம்பல் சாயம்",
  "item.minecraft.gray_dye": "சாம்பல் சாயம்",
  "item.minecraft.pink_dye": "பிங்க் டை",
  "item.minecraft.lime_dye": "சுண்ணாம்பு சாயம்",
  "item.minecraft.yellow_dye": "மஞ்சள் சாயம்",
  "item.minecraft.light_blue_dye": "வெளிர் நீல சாயம்",
  "item.minecraft.magenta_dye": "மெஜந்தா சாயம்",
  "item.minecraft.orange_dye": "ஆரஞ்சு சாயம்",
  "item.minecraft.bone_meal": "எலும்பு உணவு",
  "item.minecraft.blue_dye": "நீல சாயம்",
  "item.minecraft.brown_dye": "பிரவுன் சாயம்",
  "item.minecraft.black_dye": "பிளாக் டை",
  "item.minecraft.white_dye": "வெள்ளை சாயம்",
  "item.minecraft.bone": "எலும்பு",
  "item.minecraft.sugar": "சர்க்கரை",
  "block.minecraft.cake": "கேக்",
  "block.minecraft.white_bed": "வெள்ளை படுக்கை",
  "block.minecraft.orange_bed": "ஆரஞ்சு படுக்கை",
  "block.minecraft.magenta_bed": "மெஜந்தா படுக்கை",
  "block.minecraft.light_blue_bed": "ஒளி நீலம் படுக்கை",
  "block.minecraft.yellow_bed": "மஞ்சள் படுக்கை",
  "block.minecraft.lime_bed": "எலுமிச்சை படுக்கை",
  "block.minecraft.pink_bed": "பிங்க் படுக்கை",
  "block.minecraft.gray_bed": "கிரே படுக்கை",
  "block.minecraft.light_gray_bed": "மெல்லிய சாம்பல் நிறம் படுக்கை",
  "block.minecraft.cyan_bed": "சியான் படுக்கை",
  "block.minecraft.purple_bed": "ஊதா படுக்கை",
  "block.minecraft.blue_bed": "ப்ளூ படுக்கை",
  "block.minecraft.brown_bed": "பிரவுன் படுக்கை",
  "block.minecraft.green_bed": "பசுமை படுக்கை",
  "block.minecraft.red_bed": "ரெட் படுக்கை",
  "block.minecraft.black_bed": "பிளாக் படுக்கை",
  "item.minecraft.cookie": "குக்கீ",
  "item.minecraft.filled_map": "வரைபடம்□#0",
  "item.minecraft.shears": "ஷியர்ஸ்",
  "item.minecraft.melon_slice": "மெலோன் ஸ்லைஸ்",
  "item.minecraft.dried_kelp": "உலர்ந்த கெல்ப்",
  "item.minecraft.pumpkin_seeds": "பூசணி விதைகள்",
  "item.minecraft.melon_seeds": "முலாம்பழம் விதைகள்",
  "item.minecraft.beef": "மூல மாட்டிறைச்சி",
  "item.minecraft.cooked_beef": "ஸ்டீக்",
  "item.minecraft.chicken": "மூல கோழி",
  "item.minecraft.cooked_chicken": "சமைத்த சிக்கன்",
  "item.minecraft.rotten_flesh": "அழுகிய சதை",
  "item.minecraft.ender_pearl": "எண்டர் முத்து",
  "item.minecraft.blaze_rod": "பிளேஸ் ராட்",
  "item.minecraft.ghast_tear": "காஸ்ட் கண்ணீர்",
  "item.minecraft.gold_nugget": "தங்க நகஜ்",
  "item.minecraft.nether_wart": "நேதர் வார்ட்",
  "item.minecraft.potion": "பிரிக்க முடியாத போஷன்□விளைவுகள் இல்லை",
  "item.minecraft.glass_bottle": "கண்ணாடி குடுவை",
  "item.minecraft.spider_eye": "ஸ்பைடர் கண்",
  "item.minecraft.fermented_spider_eye": "புளிக்க ஸ்பைடர் கண்",
  "item.minecraft.blaze_powder": "பிளேஸ் தூள்",
  "item.minecraft.magma_cream": "மாக்மா கிரீம்",
  "block.minecraft.brewing_stand": "பிரவுனிங் ஸ்டேண்ட்",
  "block.minecraft.cauldron": "கொப்பரை",
  "item.minecraft.ender_eye": "எண்டரின் கண்",
  "item.minecraft.glistering_melon_slice": "மெலனோ ஸ்லஸ்",
  "item.minecraft.bat_spawn_egg": "பேட் ஸ்பான் முட்டை",
  "item.minecraft.bee_spawn_egg": "தேனீ ஸ்பான் முட்டை",
  "item.minecraft.blaze_spawn_egg": "பிளேஸ் ஸ்பான் முட்டை",
  "item.minecraft.cat_spawn_egg": "கேட் ஸ்பான் முட்டை",
  "item.minecraft.cave_spider_spawn_egg": "குகை ஸ்பைடர் ஸ்பான் முட்டை",
  "item.minecraft.chicken_spawn_egg": "சிக்கன் ஸ்பான் முட்டை",
  "item.minecraft.cod_spawn_egg": "கோட் ஸ்பான் முட்டை",
  "item.minecraft.cow_spawn_egg": "ஆடு ஸ்பூன் முட்டை",
  "item.minecraft.creeper_spawn_egg": "க்ரீப்பர் ஸ்பான் முட்டை",
  "item.minecraft.dolphin_spawn_egg": "டால்பின் ஸ்பான் முட்டை",
  "item.minecraft.donkey_spawn_egg": "கழுதை ஸ்பான் முட்டை",
  "item.minecraft.drowned_spawn_egg": "மூழ்கிய ஸ்பான் முட்டை",
  "item.minecraft.elder_guardian_spawn_egg": "மூத்த கார்டியன் ஸ்பான் முட்டை",
  "item.minecraft.enderman_spawn_egg": "எண்டர்மன் ஸ்பான் முட்டை",
  "item.minecraft.endermite_spawn_egg": "முடிந்தவரை ஸ்பான் முட்டை",
  "item.minecraft.evoker_spawn_egg": "வருவதற்காகஆர் ஸ்பான் முட்டை",
  "item.minecraft.fox_spawn_egg": "ஃபாக்ஸ் ஸ்பான் முட்டை",
  "item.minecraft.ghast_spawn_egg": "காஸ்ட் ஸ்பான் முட்டை",
  "item.minecraft.guardian_spawn_egg": "கார்டியன் ஸ்பான் முட்டை",
  "item.minecraft.hoglin_spawn_egg": "ஹாக்லின் ஸ்பான் முட்டை",
  "item.minecraft.horse_spawn_egg": "குதிரை ஸ்பான் முட்டை",
  "item.minecraft.husk_spawn_egg": "ஹஸ்ஸ்க் ஸ்பான் முட்டை",
  "item.minecraft.llama_spawn_egg": "லலாமா ஸ்பான் முட்டை",
  "item.minecraft.magma_cube_spawn_egg": "மாக்மா கியூப் ஸ்பான் முட்டை",
  "item.minecraft.mooshroom_spawn_egg": "மூசுரூம் ஸ்பான் முட்டை",
  "item.minecraft.mule_spawn_egg": "மூல் ஸ்பொன் முட்டை",
  "item.minecraft.ocelot_spawn_egg": "ஓஇஇஎல்ஓடி ஸ்பான் முட்டை",
  "item.minecraft.panda_spawn_egg": "பாண்டா ஸ்பான் முட்டை",
  "item.minecraft.parrot_spawn_egg": "கிளி ஸ்போன் முட்டை",
  "item.minecraft.phantom_spawn_egg": "ஃபாலோம் ஸ்பான் முட்டை",
  "item.minecraft.pig_spawn_egg": "பன்றி ஸ்பான் முட்டை",
  "item.minecraft.piglin_spawn_egg": "பிக்லின் ஸ்பான் முட்டை",
  "item.minecraft.pillager_spawn_egg": "பில்லேஜர் ஸ்பான் முட்டை",
  "item.minecraft.polar_bear_spawn_egg": "துருவ கரடி ஸ்பான் முட்டை",
  "item.minecraft.pufferfish_spawn_egg": "பஃபெர் மீன் ஸ்பான் முட்டை",
  "item.minecraft.rabbit_spawn_egg": "முயல் ஸ்பான் முட்டை",
  "item.minecraft.ravager_spawn_egg": "ராவஜர் ஸ்பான் முட்டை",
  "item.minecraft.salmon_spawn_egg": "சால்மன் ஸ்பான் முட்டை",
  "item.minecraft.sheep_spawn_egg": "செம்மறி ஆடு",
  "item.minecraft.shulker_spawn_egg": "ஷுல்கர் ஸ்பான் முட்டை",
  "item.minecraft.silverfish_spawn_egg": "சில்வர்ஷிப் ஸ்பான் முட்டை",
  "item.minecraft.skeleton_spawn_egg": "எலும்புக்கூடு ஸ்பொன் முட்டை",
  "item.minecraft.skeleton_horse_spawn_egg": "எலும்புக்கூட்டை குதிரை ஸ்பான் முட்டை",
  "item.minecraft.slime_spawn_egg": "ஸ்லேம் ஸ்பான் முட்டை",
  "item.minecraft.spider_spawn_egg": "ஸ்பைடர் ஸ்பான் முட்டை",
  "item.minecraft.squid_spawn_egg": "ஸ்க்விட் ஸ்பான் முட்டை",
  "item.minecraft.stray_spawn_egg": "தவறான ஸ்பான் முட்டை",
  "item.minecraft.strider_spawn_egg": "ஸ்ட்ரைடர் தோட்ற முட்டய்",
  "item.minecraft.trader_llama_spawn_egg": "வர்த்தகர் லம்மா ஸ்பான் முட்டை",
  "item.minecraft.tropical_fish_spawn_egg": "வெப்பமண்டல மீன் ஸ்பான் முட்டை",
  "item.minecraft.turtle_spawn_egg": "டர்டில் ஸ்பான் முட்டை",
  "item.minecraft.vex_spawn_egg": "ரத்து ஸ்பான் முட்டை",
  "item.minecraft.villager_spawn_egg": "வில்லர் ஸ்பான் முட்டை",
  "item.minecraft.vindicator_spawn_egg": "விண்டிகேட்டர் ஸ்பான் முட்டை",
  "item.minecraft.wandering_trader_spawn_egg": "வண்டி வர்த்தகர் ஸ்பான் முட்டை",
  "item.minecraft.witch_spawn_egg": "விட்ச் ஸ்பான் முட்டை",
  "item.minecraft.wither_skeleton_spawn_egg": "எலும்புக்கூடு ஸ்பான் முட்டை",
  "item.minecraft.wolf_spawn_egg": "ஓநாய் ஸ்பான் முட்டை",
  "item.minecraft.zoglin_spawn_egg": "ஜோக்ளின் தோட்ற முட்டய்",
  "item.minecraft.zombie_spawn_egg": "சோம்பை ஸ்பான் முட்டை",
  "item.minecraft.zombie_horse_spawn_egg": "சோம்பை குதிரை ஸ்பான் முட்டை",
  "item.minecraft.zombie_villager_spawn_egg": "ஸோம்பி வில்லேஜர் ஸ்பான் முட்டை",
  "item.minecraft.zombified_piglin_spawn_egg": "சோம்பை பிக்லின் ஸ்பான் முட்டை",
  "item.minecraft.experience_bottle": "பாட்டில் ஓ 'மயக்கும்",
  "item.minecraft.fire_charge": "தீ கட்டணம்",
  "item.minecraft.writable_book": "புத்தகம் மற்றும் குயில்",
  "item.minecraft.written_book": "எழுதப்பட்ட புத்தகம்",
  "item.minecraft.emerald": "எமரால்டு",
  "item.minecraft.item_frame": "பொருள் சட்டகம்",
  "block.minecraft.flower_pot": "மலர் பாட்",
  "item.minecraft.carrot": "கேரட்",
  "item.minecraft.potato": "உருளைக்கிழங்கு",
  "item.minecraft.baked_potato": "வேகவைத்த உருளைக்கிழங்கு",
  "item.minecraft.poisonous_potato": "விஷம் உருளைக்கிழங்கு",
  "item.minecraft.map": "வெற்று வரைபடம்",
  "item.minecraft.golden_carrot": "கோல்டன் கேரட்",
  "block.minecraft.skeleton_skull": "எலும்புக்கூடு ஸ்கல்",
  "block.minecraft.wither_skeleton_skull": "எலும்புக்கூடு மண்டை ஓடுகிறது",
  "block.minecraft.player_head": "வீரர் தலைவர்",
  "block.minecraft.zombie_head": "சோம்பை தலை",
  "block.minecraft.creeper_head": "க்ரீப்பர் ஹெட்",
  "block.minecraft.dragon_head": "டிராகன் தலைமை",
  "item.minecraft.carrot_on_a_stick": "ஒரு குச்சி மீது கேரட்",
  "item.minecraft.warped_fungus_on_a_stick": "திசைதிருப்பல் பூஞ்சை ஒரு குச்சி",
  "item.minecraft.nether_star": "நெதர் ஸ்டார்",
  "item.minecraft.pumpkin_pie": "பூசணி பை",
  "item.minecraft.firework_rocket": "வாணவேடிக்கை ராக்கெட்",
  "item.minecraft.firework_star": "வாணவேடிக்கை நட்சத்திரம்",
  "item.minecraft.enchanted_book": "மந்திரித்த புத்தகம்",
  "item.minecraft.nether_brick": "நார் செங்கல்",
  "item.minecraft.quartz": "நேதர் குவார்ட்ஸ்",
  "item.minecraft.tnt_minecart": "டி. என். டி உடன் மின்கார்ட்",
  "item.minecraft.hopper_minecart": "ஹாப்பருடன் மின்கார்ட்",
  "item.minecraft.prismarine_shard": "பிரிஸ்மரைன் ஷார்ட்",
  "item.minecraft.prismarine_crystals": "பிரிஸ்மரைன் படிகங்கள்",
  "item.minecraft.rabbit": "ரா ராபிட்",
  "item.minecraft.cooked_rabbit": "சமைத்த முயல்",
  "item.minecraft.rabbit_stew": "முயல் குண்டு",
  "item.minecraft.rabbit_foot": "முயல் அடி",
  "item.minecraft.rabbit_hide": "முயல் மறை",
  "item.minecraft.armor_stand": "ஆர்மர் ஸ்டாண்ட்",
  "item.minecraft.iron_horse_armor": "இரும்பு குதிரை கவசம்",
  "item.minecraft.golden_horse_armor": "கோல்டன் ஹார்ஸ் ஆர்மோர்",
  "item.minecraft.diamond_horse_armor": "வைர குதிரை கவசம்",
  "item.minecraft.leather_horse_armor": "தோல் குதிரை ஆர்மர்",
  "item.minecraft.lead": "முன்னணி",
  "item.minecraft.name_tag": "பெயர் டேக்",
  "item.minecraft.command_block_minecart": "கட்டளைத் தொகுதியுடன் மின்கார்ட்",
  "item.minecraft.mutton": "ரா மட்டன்",
  "item.minecraft.cooked_mutton": "சமைத்த மட்டன்",
  "block.minecraft.white_banner": "வெள்ளை பேனர்",
  "block.minecraft.orange_banner": "ஆரஞ்சு பேனர்",
  "block.minecraft.magenta_banner": "மெஜந்தா பேனர்",
  "block.minecraft.light_blue_banner": "வெளிர் நீல பதாகை",
  "block.minecraft.yellow_banner": "மஞ்சள் பேனர்",
  "block.minecraft.lime_banner": "சுண்ணாம்பு பேனர்",
  "block.minecraft.pink_banner": "பிங்க் பேனர்",
  "block.minecraft.gray_banner": "சாம்பல் பதாகை",
  "block.minecraft.light_gray_banner": "ஒளி சாம்பல் பதாகை",
  "block.minecraft.cyan_banner": "சியான் பதாகை",
  "block.minecraft.purple_banner": "ஊதா பதாகை",
  "block.minecraft.blue_banner": "நீல பேனர்",
  "block.minecraft.brown_banner": "பிரவுன் பேனர்",
  "block.minecraft.green_banner": "பச்சை பேனர்",
  "block.minecraft.red_banner": "சிவப்பு பேனர்",
  "block.minecraft.black_banner": "கருப்பு பேனர்",
  "item.minecraft.end_crystal": "முடி நீளம்",
  "item.minecraft.chorus_fruit": "கோரஸ் பழம்",
  "item.minecraft.popped_chorus_fruit": "பாப் செய்யப்பட்ட கோரஸ் பழம்",
  "item.minecraft.beetroot": "பீட்ரூட்",
  "item.minecraft.beetroot_seeds": "பீட்ரூட் விதைகள்",
  "item.minecraft.beetroot_soup": "பீட்ரூட் சூப்",
  "item.minecraft.dragon_breath": "டிராகனின் மூச்சு",
  "item.minecraft.splash_potion": "ஸ்பிளாஸ் கிராஃப்டிகல் போஷன்□விளைவுகள் இல்லை",
  "item.minecraft.spectral_arrow": "ஸ்பெக்ட்ரல் அம்பு",
  "item.minecraft.tipped_arrow": "கிராஃப்டபிள் டிப் அம்பு□விளைவுகள் இல்லை",
  "item.minecraft.lingering_potion": "நீடிக்க முடியாத கிராஃபிக் போஷன்□விளைவுகள் இல்லை",
  "item.minecraft.shield": "கேடயம்",
  "item.minecraft.elytra": "இறக்கை மூடி",
  "item.minecraft.spruce_boat": "ஸ்ப்ரூஸ் படகு",
  "item.minecraft.birch_boat": "பிர்ச் படகு",
  "item.minecraft.jungle_boat": "ஜங்கிள் படகு",
  "item.minecraft.acacia_boat": "அகாசி படகு",
  "item.minecraft.dark_oak_boat": "டார்க் ஓக் படகு",
  "item.minecraft.totem_of_undying": "மொத்தம் நீக்குதல்",
  "item.minecraft.shulker_shell": "சுல்கர் ஷெல்",
  "item.minecraft.iron_nugget": "இரும்பு நகம்",
  "item.minecraft.knowledge_book": "அறிவு புத்தகம்",
  "item.minecraft.debug_stick": "பிழைத்திருத்த ஸ்டிக்",
  "item.minecraft.music_disc_13": "இசை டிஸ்க்□c418 - 13",
  "item.minecraft.music_disc_cat": "இசை டிஸ்க்□c418 - cat",
  "item.minecraft.music_disc_blocks": "இசை டிஸ்க்□c418 - blocks",
  "item.minecraft.music_disc_chirp": "இசை டிஸ்க்□c418 - chirp",
  "item.minecraft.music_disc_far": "இசை டிஸ்க்□c418 - far",
  "item.minecraft.music_disc_mall": "இசை டிஸ்க்□c418 - mall",
  "item.minecraft.music_disc_mellohi": "இசை டிஸ்க்□c418 - mellohi",
  "item.minecraft.music_disc_stal": "இசை டிஸ்க்□c418 - stal",
  "item.minecraft.music_disc_strad": "இசை டிஸ்க்□c418 - strad",
  "item.minecraft.music_disc_ward": "இசை டிஸ்க்□c418 - ward",
  "item.minecraft.music_disc_11": "இசை டிஸ்க்□c418 - 11",
  "item.minecraft.music_disc_wait": "இசை டிஸ்க்□c418 - wait",
  "item.minecraft.music_disc_pigstep": "இசை டிஸ்க்□லீனா ரெய்ன் - பிக்ஸ்டெப்",
  "item.minecraft.trident": "திரிசூலம்□□முக்கிய கையில் இருக்கும்போது:□+8 தாக்குதலால் சேதம்□-2.9 தாக்குதல் வேகம்",
  "item.minecraft.phantom_membrane": "பாண்டம் மெம்பிரேன்",
  "item.minecraft.nautilus_shell": "நாட்டிலஸ் ஷெல்",
  "item.minecraft.heart_of_the_sea": "கடல் இதயம்",
  "item.minecraft.crossbow": "கிராஸ்போ",
  "item.minecraft.suspicious_stew": "சந்தேகத்திற்கிடமான குண்டு",
  "block.minecraft.loom": "தறி",
  "item.minecraft.flower_banner_pattern": "பேனர் பேட்டர்ன்□மலர் கட்டணம்",
  "item.minecraft.creeper_banner_pattern": "பேனர் பேட்டர்ன்□வேகம் சார்ஜ்",
  "item.minecraft.skull_banner_pattern": "பேனர் பேட்டர்ன்□ஸ்கல் சார்ஜ்",
  "item.minecraft.mojang_banner_pattern": "பேனர் பேட்டர்ன்□திங்",
  "item.minecraft.globe_banner_pattern": "பதாகை பேட்டர்ன்□குளோப்",
  "item.minecraft.piglin_banner_pattern": "பேனர் பேட்டர்ன்□முனகல்",
  "block.minecraft.composter": "உரமாக்கல்",
  "block.minecraft.barrel": "பேரல்",
  "block.minecraft.smoker": "ஸ்மோக்கர்",
  "block.minecraft.blast_furnace": "குண்டு வெடிப்பு",
  "block.minecraft.cartography_table": "வரைபட அட்டவணை",
  "block.minecraft.fletching_table": "ஃபிளெக்கிங் டேபிள்",
  "block.minecraft.grindstone": "அம்மி",
  "block.minecraft.lectern": "இதனூடாக",
  "block.minecraft.smithing_table": "ஸ்மிமிங் டேபிள்",
  "block.minecraft.stonecutter": "கல்கட்டர்",
  "block.minecraft.bell": "பெல்",
  "block.minecraft.lantern": "விளக்கு",
  "block.minecraft.soul_lantern": "சோல் விளக்கு",
  "item.minecraft.sweet_berries": "இனிப்பு பெர்ரி",
  "block.minecraft.campfire": "முகாமில் மூட்டும் நெருப்பு",
  "block.minecraft.soul_campfire": "சோல் கேம்ப்ஃபயர்",
  "block.minecraft.shroomlight": "ஷ்ரூம்லைட்",
  "item.minecraft.honeycomb": "தேன்கூடு",
  "block.minecraft.bee_nest": "தேனீ கூடு",
  "block.minecraft.beehive": "தேன் கூடு",
  "item.minecraft.honey_bottle": "ஒரு பாட்டில் தேன்",
  "block.minecraft.honey_block": "தேன் தொகுதி",
  "block.minecraft.honeycomb_block": "தேன்கூடு தொகுதி",
  "block.minecraft.lodestone": "மடய்கல்",
  "block.minecraft.netherite_block": "நெதரைட்டின் தொகுதி",
  "block.minecraft.ancient_debris": "பண்டைய குப்பைகள்",
  "block.minecraft.target": "இலக்கு",
  "block.minecraft.crying_obsidian": "அழுகை அப்சிடியன்",
  "block.minecraft.blackstone": "கருப்புக்கல்",
  "block.minecraft.blackstone_slab": "கருப்புக்கல் பலகை",
  "block.minecraft.blackstone_stairs": "கருப்புக்கல் படிக்கட்டுக்கள்",
  "block.minecraft.gilded_blackstone": "கில்டட் பிளாக்ஸ்டோன்",
  "block.minecraft.polished_blackstone": "மெருகூட்டப்பட்ட பிளாக்ஸ்டோன்",
  "block.minecraft.polished_blackstone_slab": "மெருகூட்டப்பட்ட பிளாக்ஸ்டோன் ஸ்லாப்",
  "block.minecraft.polished_blackstone_stairs": "மெருகூட்டப்பட்ட பிளாக்ஸ்டோன் படிக்கட்டுகள்",
  "block.minecraft.chiseled_polished_blackstone": "வெட்டப்பட்ட மெருகூட்டப்பட்ட பிளாக்ஸ்டோன்",
  "block.minecraft.polished_blackstone_bricks": "மெருகேற்றப்பட்ட கருப்புக்கல் செங்கற்கள்",
  "block.minecraft.polished_blackstone_brick_slab": "மெருகேற்றப்பட்ட கருப்புக்கல் செங்கல் பலகை",
  "block.minecraft.polished_blackstone_brick_stairs": "மெருகேற்றப்பட்ட கருப்புக்கல் செங்கல் படிக்கட்டுகள்",
  "block.minecraft.cracked_polished_blackstone_bricks": "கிராக் செய்யப்பட்ட பளபளப்பான பிளாக்ஸ்டோன் செங்கற்கள்",
  "block.minecraft.respawn_anchor": "மறுதோற்ற நங்கூரம்",
}
export const ta_in = items; 
